import { Color } from '@/constants/color';
import { StaffProfile } from '@/types/staffProfile';
import Badge from '@/ui/components/Badge';
import Heading from '@/ui/components/Heading';

import { parseAbout, PILL_SECTIONS } from './parseAbout';
import { Props } from './types';

const H3_SECTIONS = new Set(['About me']);

const StaffProfileCard = ({ profile }: Props) => {
  const sections = parseAbout(profile.about);
  const uniqueCredentials = [...new Set(profile.staff.credentials)].filter(Boolean);

  return (
    <div className="max-w-md">
      <Heading value={3} className="font-semibold mb-2">
        My Care Team Profile
      </Heading>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex flex-col items-center text-center gap-1 mb-6">
          {profile.photo_url && (
            <img
              src={profile.photo_url}
              alt={`${profile.staff.first_name} ${profile.staff.last_name}`}
              className="w-28 h-28 rounded-full object-cover mb-2 bg-gray-200"
            />
          )}
          <Heading value={2} className="font-bold">
            {profile.staff.display_name || `${profile.staff.first_name} ${profile.staff.last_name}`}
          </Heading>
          {profile.staff.primary_role && (
            <p className="text-sm text-gray-500 italic">{profile.staff.primary_role.name}</p>
          )}
        </div>

        <div className="space-y-5">
          {uniqueCredentials.length > 0 && (
            <div>
              <Heading value={4} className="font-semibold mb-1">
                Credentials &amp; Certifications
              </Heading>
              <p className="text-sm text-gray-700">{uniqueCredentials.join(', ')}</p>
            </div>
          )}

          {sections.map((section, idx) => (
            <div key={section.title || idx}>
              {section.title && (
                <Heading
                  value={H3_SECTIONS.has(section.title) ? 3 : 4}
                  className="font-semibold mb-1">
                  {section.title}
                </Heading>
              )}
              {PILL_SECTIONS.has(section.title) ? (
                <div className="flex flex-wrap gap-2">
                  {section.content
                    .split(',')
                    .map((item) => item.trim())
                    .filter(Boolean)
                    .map((item) => (
                      <Badge key={item} color={Color.SLATE} text={item} />
                    ))}
                </div>
              ) : (
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{section.content}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StaffProfileCard;

export type { Props, StaffProfile };
